export default "__VITE_ASSET__D2kqy8yV__"